module.exports = __webpack_public_path__ + "media/icons/success-3be93c40.svg";